module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('section', {
    staticClass: "hotel-content"
  }, [_c('div', {
    staticClass: "hot-logo"
  }, [_c('h3', [_c('span', {
    staticClass: "red"
  }, [_vm._v(_vm._s(_vm.setTitle) + "-")]), _c('span', {
    staticClass: "red"
  }, [_vm._v("HOT")]), _c('span', [_vm._v("EL")])]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("热点商务洽谈酒店介绍")])]), _vm._v(" "), (_vm.show_the_model) ? _c('ul', {
    staticClass: "hotel-list"
  }, _vm._l((_vm.items), function(item) {
    return _c('li', [_c('router-link', {
      staticClass: "hot_img_box",
      attrs: {
        "to": _vm.pagePath + item.id
      }
    }, [_c('app-img', {
      attrs: {
        "src": item.poster.url,
        "size": "small"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img_info"
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  })) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-50158506!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/HotelMode.vue
// module id = 175
// module chunks = 1